export default __webpack_public_path__ + "static/media/washStudioLogo1.d682dacf.png";